<div class="md-input-v2">
	<input [type]="type"
	       [disabled]="disabled"
	       [placeholder]="caption"
	       [(ngModel)]="value"
	       [pattern]="pattern"
	       [required]="required"
	       [min]="min"
	       [max]="max"
	       [minlength]="minlength"
	       [maxlength]="maxlength"
	       [step] ="step"
	       autocomplete="off"
         #ctrl
	>
	<label [ngClass]="{'disabled': ctrl.disabled}">{{caption}}</label>
	<span>{{hintText}}</span>
</div>
